/**
 * Theme tokens — the single client-side mirror of the prototype's visual
 * contract (`docs/design/flow/ponpon.css` `:root` custom properties). A palette
 * tweak is one edit here (and one in `ponpon.css`); UI code reads from this
 * object instead of hard-coding hex values.
 *
 * Keep this in sync with `ponpon.css` `:root`. When the UI Designer changes a
 * token there, mirror it here in the same commit that integrates the change.
 */

export const COLORS = {
  // world
  sky0: '#9fd9ef',
  sky1: '#c7ecf2',
  meadow: '#bfe39a',
  hill0: '#7cc24a',
  hill1: '#5fa838',
  soil: '#8a5a34',
  soilD: '#6b4424',
  soilL: '#a8754a',
  // wood + parchment UI
  wood: '#a9763f',
  woodD: '#7c5024',
  woodL: '#c79055',
  panel: '#f5e6c2',
  panelHi: '#fdf3d8',
  panelLo: '#ead2a0',
  stroke: '#b9894e',
  strokeSoft: '#d4b375',
  // ink
  ink: '#4a3220',
  inkDim: '#7c6244',
  inkFaint: '#a98c63',
  // accents
  gold: '#f3b33a',
  goldD: '#c98a22',
  teal: '#52b39a',
  tealD: '#357f6c',
  pink: '#ec6a86',
  pinkD: '#c4475f',
  leaf: '#6ab04c',
  leafD: '#4d8a33',
  danger: '#e0556b',
  ok: '#6ab04c',
  // the dark stage backdrop behind the device frame
  stageBg: '#1c130b',
} as const;

export const RADII = {
  sm: 10,
  md: 14,
  lg: 20,
  xl: 28,
} as const;

export const FONTS = {
  body: "'Fredoka','Trebuchet MS','Segoe UI',system-ui,sans-serif",
  display: "'Fredoka','Trebuchet MS',sans-serif",
} as const;

/**
 * The prototype is designed at a fixed landscape "phone" resolution
 * (`.screen` inside the 880x430 device frame in `ponpon.css`). The Phaser
 * canvas uses the inner screen size; the device frame is chrome.
 */
export const SCREEN = {
  width: 880,
  height: 430,
} as const;
